export enum ObjectFitEnum {
	COVER ,
	CONTAIN ,
}

export enum MediaSourceEnum {
	DRAWER,
	SECTION ,
	CAROUSEL,
	CAROUSEL_STATIC
}



